import { IRackModalProps } from "./RackModal.props";
import { ActionType, useRackModalColntrol } from "./useRackModalControl";
import styles from "./RackModal.module.scss";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Selector from "@components/global/new/Selector/Selector";
import { InputNumber, Tabs, TabsProps } from "antd";
import RackEditComponent from "@components/modals/newModals/RackModal/RackEditComponent/RackEditComponent";
import { useIntl } from "react-intl";

function RackModal({ ...props }: IRackModalProps) {
  const { formatMessage } = useIntl();
  const control = useRackModalColntrol(props);
  const title = props.rack
    ? `${formatMessage({ id: "modal.rack.title.edit" })} #${props.rack.rack_id}`
    : props.availableRack
    ? `${formatMessage({ id: "modal.rack.title.edit_available" })} ${
        props.availableRack.rack_type[1]
      }x${props.availableRack.rack_type[0]}`
    : formatMessage({ id: "modal.rack.title.create" });

  const items: TabsProps["items"] = [
    {
      key: "SELECT" as ActionType,
      label: formatMessage({ id: "modal.rack.select.type" }),
      children: (
        <Selector
          className={styles.selector}
          options={control.templateTypesStrings}
          onChange={(e: any) => control.onChangeRackType(e.target.value)}
        />
      ),
      disabled: !!props.rack,
    },
    {
      key: "OWN" as ActionType,
      label: formatMessage({ id: "modal.rack.select.own" }),
      children: (
        <div className={styles.own_type}>
          <InputNumber
            min={1}
            className={styles.input}
            value={control.widthValue}
            onChange={(value) => control.setWidthValue(value || 1)}
            type='number'
            status={
              control.widthValue === 0 || control.fieldsError
                ? "error"
                : undefined
            }
          />
          <InputNumber
            min={1}
            className={styles.input}
            value={control.heightValue}
            onChange={(value) => control.setHeightValue(value || 1)}
            type='number'
            status={
              control.heightValue === 0 || control.fieldsError
                ? "error"
                : undefined
            }
          />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.content}>
        <div className={styles.header}>
          <Tabs
            defaultActiveKey={control.rackAction}
            items={items}
            onChange={(key) => control.onChangeRackAction(key as ActionType)}
          />
          {/* <Switch
            checked={control.reversed}
            onChange={control.onChangeReversed}
            checkedChildren='bottom-top'
            unCheckedChildren='top-bottom'
          /> */}
        </div>
        <RackEditComponent
          type={control.rackType}
          lastType={control.lastSelectedRackType}
          availableRack={props.availableRack}
          rack={props.rack}
          rackTypeError={control.fieldsError}
          onClose={props.handleClose}
          reversed={control.reversed}
          update={props.update}
        />
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.RACK_MODAL, RackModal);
